import { toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row m-4 mt-0 mb-0" }
const _hoisted_2 = { class: "col-sm-12" }
const _hoisted_3 = { class: "card card-body mb-0" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "form-group col-sm-12" }
const _hoisted_6 = { class: "navbar-nav overflow-auto flex-row gap-4" }
const _hoisted_7 = { class: "nav-item nav-item-spaced d-lg-block text-nowrap" }
const _hoisted_8 = { class: "nav-item nav-item-spaced d-lg-block text-nowrap" }
const _hoisted_9 = { class: "row m-4 mt-0 mb-0" }
const _hoisted_10 = { class: "col-sm-12" }
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "col-sm-12" }
const _hoisted_13 = { class: "card card-body mb-0" }
const _hoisted_14 = { class: "row" }
const _hoisted_15 = { class: "form-group mb-2 col-md-3 col-lg-3 col-xl-2 me-2" }
const _hoisted_16 = { class: "col p-0" }
const _hoisted_17 = { class: "form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2" }
const _hoisted_18 = { class: "col p-0" }
const _hoisted_19 = ["placeholder", "value", "onFocus", "onChange"]
const _hoisted_20 = { class: "form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2" }
const _hoisted_21 = { class: "col p-0" }
const _hoisted_22 = ["placeholder", "value", "onFocus", "onChange"]
const _hoisted_23 = {
  key: 0,
  class: "form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2"
}
const _hoisted_24 = { class: "col p-0" }
const _hoisted_25 = ["placeholder"]
const _hoisted_26 = {
  key: 1,
  class: "form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2"
}
const _hoisted_27 = { class: "col p-0" }
const _hoisted_28 = ["placeholder"]
const _hoisted_29 = { class: "form-group mb-2 col" }
const _hoisted_30 = { class: "col-auto p-0 text-end" }
const _hoisted_31 = {
  key: 0,
  class: "row m-4 mb-0 mt-0"
}
const _hoisted_32 = { class: "col-sm-12" }
const _hoisted_33 = { class: "card card-body mb-0" }
const _hoisted_34 = { class: "overflow-auto" }
const _hoisted_35 = { class: "table table-bordered align-middle text-left text-nowrap position-relative" }
const _hoisted_36 = { class: "bg-light" }
const _hoisted_37 = { class: "text-capitalize-first" }
const _hoisted_38 = { class: "text-capitalize-first" }
const _hoisted_39 = { class: "text-capitalize-first" }
const _hoisted_40 = { class: "text-capitalize-first" }
const _hoisted_41 = { class: "text-capitalize-first" }
const _hoisted_42 = { class: "text-capitalize-first" }
const _hoisted_43 = { class: "text-capitalize-first" }
const _hoisted_44 = { class: "text-capitalize-first" }
const _hoisted_45 = ["title"]
const _hoisted_46 = { class: "text-end" }
const _hoisted_47 = { class: "text-end" }
const _hoisted_48 = { class: "text-end" }
const _hoisted_49 = { key: 0 }
const _hoisted_50 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_51 = { key: 0 }
const _hoisted_52 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_53 = {
  key: 0,
  class: "badge bg-danger"
}
const _hoisted_54 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_55 = { class: "text-end" }
const _hoisted_56 = ["onClick"]
const _hoisted_57 = { key: 0 }
const _hoisted_58 = {
  colspan: "9",
  class: "text-center text-muted py-3"
}
const _hoisted_59 = {
  key: 1,
  class: "row m-4 mb-0 mt-0"
}
const _hoisted_60 = { class: "col-sm-12" }
const _hoisted_61 = { class: "card card-body mb-0" }
const _hoisted_62 = { class: "overflow-auto" }
const _hoisted_63 = { class: "table table-bordered align-middle text-left text-nowrap position-relative" }
const _hoisted_64 = { class: "bg-light" }
const _hoisted_65 = { class: "text-capitalize-first" }
const _hoisted_66 = { class: "text-capitalize-first" }
const _hoisted_67 = { class: "text-capitalize-first" }
const _hoisted_68 = { class: "text-capitalize-first" }
const _hoisted_69 = { class: "text-capitalize-first" }
const _hoisted_70 = { class: "text-capitalize-first" }
const _hoisted_71 = ["title"]
const _hoisted_72 = { class: "text-end" }
const _hoisted_73 = { class: "text-end" }
const _hoisted_74 = { class: "text-end" }
const _hoisted_75 = { class: "text-end" }
const _hoisted_76 = { key: 0 }
const _hoisted_77 = {
  colspan: "6",
  class: "text-center text-muted py-3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StoreMultiselect = _resolveComponent("StoreMultiselect")!
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_copy_button = _resolveComponent("copy-button")!
  const _component_b_pagination = _resolveComponent("b-pagination")!
  const _component_MerchantUserBanModal = _resolveComponent("MerchantUserBanModal")!
  const _component_LoaderWrapper = _resolveComponent("LoaderWrapper")!
  const _directive_b_tooltip = _resolveDirective("b-tooltip")!

  return (_openBlock(), _createBlock(_component_LoaderWrapper, {
    ref: "loader",
    class: "h-100"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("ul", _hoisted_6, [
                  _createElementVNode("li", _hoisted_7, [
                    _createElementVNode("a", {
                      href: "#",
                      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.selectSubTab('general')), ["prevent"])),
                      class: _normalizeClass(["nav-link tab", { active: _ctx.activeSubTab === 'general' }])
                    }, _toDisplayString(_ctx.helper.trans('statistic.conversion.tab_general')), 3)
                  ]),
                  _createElementVNode("li", _hoisted_8, [
                    _createElementVNode("a", {
                      href: "#",
                      onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.selectSubTab('counterparty')), ["prevent"])),
                      class: _normalizeClass(["nav-link tab", { active: _ctx.activeSubTab === 'counterparty' }])
                    }, _toDisplayString(_ctx.helper.trans('statistic.conversion.tab_counterparty')), 3)
                  ])
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _createVNode(_component_StoreMultiselect, {
                        multiple: true,
                        modelValue: _ctx.storesFilter,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.storesFilter) = $event))
                      }, null, 8, ["modelValue"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                      _createVNode(_component_DatePicker, {
                        modelValue: _ctx.requestDTO.fromDate,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.requestDTO.fromDate) = $event)),
                        mode: "dateTime",
                        "model-modifiers": {string: true},
                        is24hr: "",
                        masks: {modelValue: 'YYYY-MM-DD HH:mm:ss', inputDateTime24hr: 'YYYY-MM-DD HH:mm:ss'}
                      }, {
                        default: _withCtx(({ inputValue, togglePopover, inputEvents }) => [
                          _createElementVNode("input", {
                            class: "form-control form-control-sm",
                            placeholder: _ctx.helper.trans('labels.from_date'),
                            value: inputValue,
                            onFocus: togglePopover,
                            onChange: inputEvents.change
                          }, null, 40, _hoisted_19)
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("div", _hoisted_21, [
                      _createVNode(_component_DatePicker, {
                        modelValue: _ctx.requestDTO.toDate,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.requestDTO.toDate) = $event)),
                        mode: "dateTime",
                        "model-modifiers": {string: true},
                        is24hr: "",
                        masks: {modelValue: 'YYYY-MM-DD HH:mm:ss', inputDateTime24hr: 'YYYY-MM-DD HH:mm:ss'}
                      }, {
                        default: _withCtx(({ inputValue, togglePopover, inputEvents }) => [
                          _createElementVNode("input", {
                            class: "form-control form-control-sm",
                            placeholder: _ctx.helper.trans('labels.to_date'),
                            value: inputValue,
                            onFocus: togglePopover,
                            onChange: inputEvents.change
                          }, null, 40, _hoisted_22)
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ])
                  ]),
                  (_ctx.activeSubTab === 'general')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                        _createElementVNode("div", _hoisted_24, [
                          _withDirectives(_createElementVNode("input", {
                            type: "number",
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.requestDTO.minUseCount) = $event)),
                            class: "form-control form-control-sm",
                            placeholder: _ctx.helper.trans('statistic.conversion.min_use_count'),
                            min: "0"
                          }, null, 8, _hoisted_25), [
                            [
                              _vModelText,
                              _ctx.requestDTO.minUseCount,
                              void 0,
                              { number: true }
                            ]
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.activeSubTab === 'counterparty')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                        _createElementVNode("div", _hoisted_27, [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.kaUserId) = $event)),
                            class: "form-control form-control-sm",
                            placeholder: _ctx.helper.trans('statistic.conversion.search_user_id'),
                            autocomplete: "off"
                          }, null, 8, _hoisted_28), [
                            [
                              _vModelText,
                              _ctx.kaUserId,
                              void 0,
                              { trim: true }
                            ]
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("div", _hoisted_30, [
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.applyFilters()), ["prevent"])),
                        class: "btn btn-outline-primary btn-sm rounded-pill me-2 text-capitalize-first"
                      }, _toDisplayString(_ctx.helper.trans('button.apply')), 1),
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (_ctx.clearFilters()), ["prevent"])),
                        class: "btn btn-outline-secondary btn-sm rounded-pill text-capitalize-first"
                      }, _toDisplayString(_ctx.helper.trans('button.reset')), 1)
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ]),
      (_ctx.activeSubTab === 'general')
        ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("div", _hoisted_33, [
                _createElementVNode("div", _hoisted_34, [
                  _createElementVNode("table", _hoisted_35, [
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", _hoisted_36, [
                        _createElementVNode("th", _hoisted_37, _toDisplayString(_ctx.helper.trans('labels.user_id')), 1),
                        _createElementVNode("th", _hoisted_38, _toDisplayString(_ctx.helper.trans('labels.store_id')), 1),
                        _createElementVNode("th", _hoisted_39, _toDisplayString(_ctx.helper.trans('statistic.conversion.total_use_count')), 1),
                        _createElementVNode("th", _hoisted_40, _toDisplayString(_ctx.helper.trans('statistic.conversion.total_completed')), 1),
                        _createElementVNode("th", _hoisted_41, _toDisplayString(_ctx.helper.trans('statistic.conversion.total_conversion_rate')), 1),
                        _createElementVNode("th", _hoisted_42, _toDisplayString(_ctx.helper.trans('labels.first_used_at')), 1),
                        _createElementVNode("th", _hoisted_43, _toDisplayString(_ctx.helper.trans('labels.last_used_at')), 1),
                        _createElementVNode("th", _hoisted_44, _toDisplayString(_ctx.helper.trans('labels.is_banned')), 1),
                        _cache[13] || (_cache[13] = _createElementVNode("th", null, null, -1))
                      ])
                    ]),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.response.items, (item, index) => {
                        return (_openBlock(), _createElementBlock("tr", { key: index }, [
                          _createElementVNode("td", null, [
                            _withDirectives((_openBlock(), _createElementBlock("span", {
                              title: item.userId
                            }, [
                              _createTextVNode(_toDisplayString(item.userId.substring(0, 8)) + "...", 1)
                            ], 8, _hoisted_45)), [
                              [
                                _directive_b_tooltip,
                                void 0,
                                void 0,
                                { hover: true }
                              ]
                            ]),
                            _createVNode(_component_copy_button, {
                              class: "ms-1",
                              value: item.userId
                            }, null, 8, ["value"])
                          ]),
                          _createElementVNode("td", null, _toDisplayString(item.storeId), 1),
                          _createElementVNode("td", _hoisted_46, _toDisplayString(_ctx.numberFormatter.formatNumber(item.totalUseCount)), 1),
                          _createElementVNode("td", _hoisted_47, _toDisplayString(_ctx.numberFormatter.formatNumber(item.totalCompleted)), 1),
                          _createElementVNode("td", _hoisted_48, _toDisplayString(_ctx.numberFormatter.formatNumber(item.totalConversionRate, 2)) + "%", 1),
                          _createElementVNode("td", null, [
                            (item.firstUsedAt)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_49, _toDisplayString(_ctx.dateHelper.format(item.firstUsedAt, 'YYYY-MM-DD')), 1))
                              : (_openBlock(), _createElementBlock("span", _hoisted_50, "—"))
                          ]),
                          _createElementVNode("td", null, [
                            (item.lastUsedAt)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_51, _toDisplayString(_ctx.dateHelper.format(item.lastUsedAt, 'YYYY-MM-DD')), 1))
                              : (_openBlock(), _createElementBlock("span", _hoisted_52, "—"))
                          ]),
                          _createElementVNode("td", null, [
                            (item.isBanned)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_53, _toDisplayString(_ctx.helper.trans('labels.banned')), 1))
                              : (_openBlock(), _createElementBlock("span", _hoisted_54, "—"))
                          ]),
                          _createElementVNode("td", _hoisted_55, [
                            (!item.isBanned)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  type: "button",
                                  onClick: ($event: any) => (_ctx.openBanPopup(item)),
                                  class: "btn btn-sm btn-outline-danger text-nowrap text-capitalize-first"
                                }, _toDisplayString(_ctx.helper.trans('button.ban')), 9, _hoisted_56))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      }), 128)),
                      (_ctx.response.items.length === 0)
                        ? (_openBlock(), _createElementBlock("tr", _hoisted_57, [
                            _createElementVNode("td", _hoisted_58, _toDisplayString(_ctx.helper.trans('labels.no_history')), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  (_ctx.response.totalCount > _ctx.response.items.length)
                    ? (_openBlock(), _createBlock(_component_b_pagination, {
                        key: 0,
                        modelValue: _ctx.page,
                        "onUpdate:modelValue": [
                          _cache[9] || (_cache[9] = ($event: any) => ((_ctx.page) = $event)),
                          _cache[10] || (_cache[10] = ($event: any) => (_ctx.load()))
                        ],
                        "total-rows": _ctx.response.totalCount,
                        "per-page": _ctx.response.limit,
                        limit: 20,
                        "prev-text": "Back",
                        "next-text": "Next",
                        align: "start",
                        "first-number": "",
                        "hide-goto-end-buttons": "",
                        "hide-ellipsis": ""
                      }, null, 8, ["modelValue", "total-rows", "per-page"]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.activeSubTab === 'counterparty')
        ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
            _createElementVNode("div", _hoisted_60, [
              _createElementVNode("div", _hoisted_61, [
                _createElementVNode("div", _hoisted_62, [
                  _createElementVNode("table", _hoisted_63, [
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", _hoisted_64, [
                        _createElementVNode("th", _hoisted_65, _toDisplayString(_ctx.helper.trans('labels.store_id')), 1),
                        _createElementVNode("th", _hoisted_66, _toDisplayString(_ctx.helper.trans('statistic.conversion.counterparty_id')), 1),
                        _createElementVNode("th", _hoisted_67, _toDisplayString(_ctx.helper.trans('statistic.conversion.trader_id')), 1),
                        _createElementVNode("th", _hoisted_68, _toDisplayString(_ctx.helper.trans('statistic.conversion.issued_deals')), 1),
                        _createElementVNode("th", _hoisted_69, _toDisplayString(_ctx.helper.trans('statistic.conversion.not_issued')), 1),
                        _createElementVNode("th", _hoisted_70, _toDisplayString(_ctx.helper.trans('statistic.conversion.total_conversion_rate')), 1)
                      ])
                    ]),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.kaResponse.items, (item) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: `${item.storeId}-${item.userId}-${item.traderId}`
                        }, [
                          _createElementVNode("td", null, _toDisplayString(item.storeId), 1),
                          _createElementVNode("td", null, [
                            _withDirectives((_openBlock(), _createElementBlock("span", {
                              title: item.userId
                            }, [
                              _createTextVNode(_toDisplayString(item.userId.substring(0, 8)) + "...", 1)
                            ], 8, _hoisted_71)), [
                              [
                                _directive_b_tooltip,
                                void 0,
                                void 0,
                                { hover: true }
                              ]
                            ]),
                            _createVNode(_component_copy_button, {
                              class: "ms-1",
                              value: item.userId
                            }, null, 8, ["value"])
                          ]),
                          _createElementVNode("td", _hoisted_72, _toDisplayString(item.traderId), 1),
                          _createElementVNode("td", _hoisted_73, _toDisplayString(_ctx.numberFormatter.formatNumber(item.issuedCount)), 1),
                          _createElementVNode("td", _hoisted_74, _toDisplayString(_ctx.numberFormatter.formatNumber(item.notIssuedCount)), 1),
                          _createElementVNode("td", _hoisted_75, _toDisplayString(_ctx.numberFormatter.formatNumber(item.conversionRate, 2)) + "%", 1)
                        ]))
                      }), 128)),
                      (_ctx.kaResponse.items.length === 0)
                        ? (_openBlock(), _createElementBlock("tr", _hoisted_76, [
                            _createElementVNode("td", _hoisted_77, _toDisplayString(_ctx.helper.trans('labels.no_history')), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  (_ctx.kaResponse.totalCount > _ctx.kaResponse.items.length)
                    ? (_openBlock(), _createBlock(_component_b_pagination, {
                        key: 0,
                        modelValue: _ctx.kaPage,
                        "onUpdate:modelValue": [
                          _cache[11] || (_cache[11] = ($event: any) => ((_ctx.kaPage) = $event)),
                          _cache[12] || (_cache[12] = ($event: any) => (_ctx.loadKa()))
                        ],
                        "total-rows": _ctx.kaResponse.totalCount,
                        "per-page": _ctx.kaResponse.limit,
                        limit: 20,
                        "prev-text": "Back",
                        "next-text": "Next",
                        align: "start",
                        "first-number": "",
                        "hide-goto-end-buttons": "",
                        "hide-ellipsis": ""
                      }, null, 8, ["modelValue", "total-rows", "per-page"]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_MerchantUserBanModal, {
        ref: "banPopup",
        onBanned: _ctx.onBanned
      }, null, 8, ["onBanned"])
    ]),
    _: 1
  }, 512))
}